import React from "react";
import "./RuaAutocomplete.css"

export const RuaAutoComplete = ({ endereco, setEndereco, bairro, cidade = "Santa Cruz" }) => {
    void bairro;
    void cidade;

    return (
        <div className="autocomplete-container">
            <input
                placeholder="ENDEREÇO (RUA)"
                required
                maxLength={200}
                value={endereco}
                onChange={(e) => setEndereco(e.target.value)}
            />
        </div>
    );
};
